import i18n from '../../i18n';

export const INSTITUTION_CODE_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/**
 * Validates an institution code's format. Caller must lowercase the input first.
 * Returns null when valid, otherwise the user-facing error message.
 */
export function validateCodeFormat(code: string): string | null {
  if (code.length < 2 || code.length > 15) {
    return i18n.t('institutions:code.length');
  }
  if (!INSTITUTION_CODE_REGEX.test(code)) {
    return i18n.t('institutions:code.format');
  }
  return null;
}
